<template>
    <Popup :popup_style="popup_style" >
        <template>
            <div class="loading_box">
                <div>
                    <div class="loading_icon">
                        <Loading color="#1989fa" />
                    </div>
                    <div class="loading_text">
                        加载中{{icon_list}}
                    </div>
                </div>
            </div>
        </template>
    </Popup>
</template>
<script>
import Popup from '@/components/Popup';
import { Loading } from 'vant';
export default {
    name: 'SelfLoading',
    data(){
        return{
            popup_style: {
                backgroundColor:'rgba(0,0,0,0)',
            },
            icon_list: '',
            timer: null,
        }
    },
    components:{
        Popup,
        Loading,
    },
    mounted(){
        let len = 1
        this.timer = setInterval(()=>{
            len ++
            let __icon = ''
            for(let i = 0; i < (len%4) ; i++){
                __icon += '.'
            }
            this.icon_list = __icon
        },500)
    },
    beforeDestroy() {
      clearInterval(this.timer)  
    },
    
}
</script>
<style lang="scss" scoped>
    @import './index.scss'
</style>